import { Optional } from "common/utils/types";
import { toDollars } from "common/utils/formatting";
import { IDeliveryOption } from "common/types/carts";

import SelectPanel from "client/common/components/inputs/SelectPanel";
import TextHighlight from "client/common/components/content/TextHighlight";

import styles from "../../styles/shared/DeliveryGroupMethodSelectPanel.module.less";

type DeliveryGroupMethodSelectPanelProps = {
  options: IDeliveryOption[];
  value: Optional<IDeliveryOption>;
  loadingValue?: Optional<IDeliveryOption>;
  disabled?: boolean;
  onClick?: (value: IDeliveryOption) => void;
  onChange?: (value: IDeliveryOption) => void;
};

const DeliveryGroupMethodSelectPanel = ({
  options,
  value,
  loadingValue,
  disabled,
  onClick,
  onChange,
}: DeliveryGroupMethodSelectPanelProps) => {
  const getKey = (deliveryOption: Optional<IDeliveryOption>) => {
    return deliveryOption ? `${deliveryOption.kind}-${deliveryOption.key}` : "";
  };

  return (
    <SelectPanel
      entityName="Delivery Method"
      getKey={getKey}
      getState={(deliveryOption) => ({
        isLoading: getKey(loadingValue) === getKey(deliveryOption),
        disabled,
      })}
      options={options}
      renderOption={({ title, description, cost }, { status }) => (
        <div className={styles.option}>
          <div>
            <div className={styles.label}>{title}</div>
            <div className={styles.description}>{description}</div>
          </div>
          <div className={styles.status}>
            <div className={styles.price}>
              {cost ? (
                toDollars(cost)
              ) : (
                <TextHighlight weight="medium" variant="success">
                  FREE
                </TextHighlight>
              )}
            </div>
            {status}
          </div>
        </div>
      )}
      value={value}
      onClick={onClick}
      onChange={onChange}
    />
  );
};

export default DeliveryGroupMethodSelectPanel;
